module.exports = __webpack_public_path__ + "static/img/c4-3.2a69f66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/c4-3.png
// module id = 880
// module chunks = 1